// Copyright (c) 2025 Nebularis Holdings LLC
// Licensed to Nutrx Solutions under a non-exclusive, non-transferable license.
// See IP License Agreement for usage restrictions.
// frontend/src/components/mission-launch/shared/ReadinessScore.jsx

import React from 'react';

export default function ReadinessScore({ score = 0, label = 'Operational Readiness', detail = '' }) {
  const normalized = Math.max(0, Math.min(100, Number(score) || 0));
  return (
    <div className="readiness-score" style={{ '--readiness': `${normalized}%` }}>
      <div className="readiness-score-ring" aria-hidden="true">
        <span>{normalized}%</span>
      </div>
      <div className="readiness-score-copy">
        <p className="mission-launch-eyebrow">Mission Readiness</p>
        <h3>{label}</h3>
        <div className="readiness-score-bar"><span /></div>
        {detail ? <p>{detail}</p> : null}
      </div>
    </div>
  );
}
